import { useCallback } from "react";
import { useTranslation } from 'react-i18next';

import { Box, Dropdown, Option, OptionDescription } from "@launchmetrics/lm-ui";

import { ReactComponent as XlsIcon } from 'vendor/svg/report/xls-icon.svg';
import { ReactComponent as OnlineIcon } from 'vendor/svg/report/online-icon.svg';
import { ReactComponent as ReportIcon } from 'vendor/svg/report/report-manager.svg';
import { ReactComponent as PowerpointIcon } from 'vendor/svg/report/powerpoint-icon.svg';

import { setReportType } from "store/article/report/reducers";

import { useStyles } from "./styles";
import { useDispatch } from "react-redux";

export function ReportDropdown() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { reportDropdownTitle } = useStyles();

	const showReportPanel = useCallback(value => {
		dispatch(setReportType({ type: value }));
	}, [dispatch]);

	return (
		<Dropdown
			id="reportDropdownBtn"
			label={t('reports_manager.article.dropdown.label')}
			leftIcon={<ReportIcon />}
			onChange={value => showReportPanel(value)}
			variant="primary"
			popoverProps={{ placement: 'bottom-end' }}
		>
			<>
				<Option id="reportDropdownExcelBtn" value="excel">
					<Box styleProps={reportDropdownTitle}><XlsIcon />{t('reports_manager.article.dropdown.excel.title')}</Box>
					<OptionDescription>
						{t('reports_manager.article.dropdown.excel.subtitle')}
					</OptionDescription>
				</Option>
				<Option id="reportDropdownPowerpointBtn" value="powerpoint">
					<Box styleProps={reportDropdownTitle}><PowerpointIcon />{t('reports_manager.article.dropdown.powerpoint.title')}</Box>
					<OptionDescription>
						{t('reports_manager.article.dropdown.powerpoint.subtitle')}
					</OptionDescription>
				</Option>
				<Option id="reportDropdownOnlineBtn" value="online">
					<Box styleProps={reportDropdownTitle}><OnlineIcon />{t('reports_manager.article.dropdown.online.title')}</Box>
					<OptionDescription>
						{t('reports_manager.article.dropdown.online.subtitle')}
					</OptionDescription>
				</Option>
			</>
		</Dropdown>
	);
}
